import templateUrl from "./newsletter.html";
import { range, findIndex, assign } from "lodash";
import "./newsletter.scss";

export const newsletterComponent = {
  templateUrl,
  bindings: {
    details: "<",
  },

  controller: class NewsletterComponent {
    constructor($state, SettingsService, AdvertisementsService, toastr) {
      "ngInject";

      this.$state = $state;
      this.toastr = toastr;
      this.SettingsService = SettingsService;
      this.AdvertisementsService = AdvertisementsService;
    }
    $onInit() {
      this.disableButtons = false;
      this.enabled = false;
      this.days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      this.hours = range(1, 13);
      this.amPm = "pm";
      if (this.details.values) {
        if (this.details.values.enabled) {
          this.enabled = this.details.values.enabled;
        }
        if (this.details.values.dayOfWeek) {
          this.selectedDayOfWeek = this.days[this.details.values.dayOfWeek];
        }
        if (this.details.values.hour) {
          if (this.details.values.hour === 0 || this.details.values.hour < 12) {
            this.amPm = "am";
          } else {
            this.amPm = "pm";
          }

          if (this.details.values.hour === 0) {
            // 12 am
            this.hour = 12;
          } else if (this.details.values.hour > 12) {
            this.hour = this.details.values.hour - 12;
          } else {
            this.hour = this.details.values.hour;
          }

          if (this.hour) {
            this.hour = this.hour.toString();
          }
        }
        if (this.details.values.advertisementId) {
          this.selectedAdvertisementId =
            this.details.values.advertisementId.toString();
          this.AdvertisementsService.getAdvertisementsEditDetails(
            this.details.values.advertisementId
          ).then((details) => {
            this.advertisementDetails = details;
          });
        }
      }
      // fetch the list of advertisements
      this.AdvertisementsService.getAdvertisementList().then((details) => {
        this.advertisements = details.advertisementList.map((advertisement) => {
          // add the label as 'inactive' for inactive advertisement
          return assign(advertisement, {
            title: advertisement.isActive
              ? advertisement.name
              : `${advertisement.name} (Inactive)`,
          });
        });
      });
    }
    onSubmit() {
      this.disableButtons = true;
      const hour = (() => {
        if (this.hour) {
          if (this.amPm === "am" && parseInt(this.hour) === 12) {
            return 0;
          }
          if (this.amPm === "pm" && parseInt(this.hour) !== 12) {
            return parseInt(this.hour) + 12;
          }
          return parseInt(this.hour);
        }
        return null;
      })();
      this.SettingsService.updateSettingDetails(this.details.name, {
        value: {
          enabled: this.enabled,
          dayOfWeek: this.selectedDayOfWeek
            ? findIndex(this.days, (day) => day === this.selectedDayOfWeek)
            : null,
          hour,
          advertisementId: this.selectedAdvertisementId
            ? parseInt(this.selectedAdvertisementId)
            : null,
        },
      })
        .then(() => {
          this.disableButtons = false;
          this.toastr.success("Settings updated successfully");
        })
        .catch((error) => {
          this.disableSubmitBtn = false;
          this.toastr.error(error.data.errors.message);
        });
    }

    onCancel() {
      this.$state.go("settings");
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/settings/components/newsletter/newsletter.component.js